<template>
  <ul class="listOfProducts">
    <li v-for="(product, index) in products" :key="index" class="product">
      <div style="width: 100%;">
        <!-- <div style="width: 30%; float: left;" class="image"> -->
          <!-- <img :src="imgPreUrl+product.product_image_url" alt="" class="product-image"> -->
         <img :src="product.product_image_s3_url ? product.product_image_s3_url :'' " :alt="product.product_image_s3_url ? product.product_image_s3_url :'No Image'" class="product-image">
          <!-- <div class="imageText">
            <p>Out Of Stock</p>
          </div> -->
        <!-- </div> -->
        <div style="width: 65%; float: right;">
          <div>
            <b>{{ product.product_name }}</b><br>
            <div style="color: gray; font-size: 13px; font-style:italic">{{ product.product_description }}</div>
            <div style="font-size: 14px;">{{product.product_price_list[0].quantity}} {{product.product_price_list[0].unit}}</div>
            <div style="width: 100%;">
              <div style="width: 30%; float: left;font-size: 13px;">
                <div v-if="product.flat_discount_mrp_applicable === false">
                  <div style="float: left;"><i class="fa fa-rupee"></i> <b>{{ product.product_price.toFixed(2) }}</b></div>
                </div>
                <div v-else>
                  <div style="float: left;text-decoration: line-through;color: gray;"><i class="fa fa-rupee"></i> <b>{{ product.mrp_without_discount.toFixed(2) }}</b></div><br>
                  <div style="float: left;"><i class="fa fa-rupee"></i> <b>{{ product.product_price.toFixed(2) }}</b></div>
                </div>
              </div>
              <div  style="float: right;">
                <btn 
                  v-bind:style="{'background-color': product.button_color}"
                  class="subButton"
                  @click.native="onClickSubButton(product)">
                  {{ product.btn_text}}
                </btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'
import btn from './Btn'
import axios from 'axios'
export default {
  props: ['products'],

  components: {
    btn
  },
  data () {
    return {
      imgPreUrl: 'https://doodhvale.in'
    }
  },
  created () {
    // console.log(this.$props.products)
  },
  methods: {
    ...mapActions([
      'addProduct',
      'currentProduct'
    ]),

    addProductToCart (product) {
      this.addProduct(product)
    },
    onClickSubButton (productList) {
      // console.log(productList)
      // alert(productList.product_id)
      if (productList.btn_text === 'NOTIFY ME') {
        // alert('notified')
        this.$swal.fire({
          text: 'Do you want to get notified when this product is in store?',
          showCancelButton: true,
          confirmButtonColor: '#3CB6C3',
          cancelButtonColor: '#3CB6C3',
          confirmButtonText: 'No',
          cancelButtonText: 'Yes'
        }).then((result) => {
          if (result.value) {
            // alert('no')
          } else {
            const params = new URLSearchParams()
            params.append('action_name', 'notify_for_product')
            params.append('user_id', sessionStorage.getItem('userId'))
            params.append('product_id', productList.product_id)
            axios({
              url: process.env.BASE_API + '/users/invoke-user-action',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {
              }
            })
            .then(response => {
              // console.log(response)
              window.location.reload()
            })
            .catch(e => {
              alert('not ok')
            })
          }
        })
      } else if (productList.is_button_enable === 1) {
        sessionStorage.setItem('productId', productList.product_id)
        sessionStorage.setItem('productName', productList.product_name)
        sessionStorage.setItem('productImageUrl', productList.product_image_s3_url)
        sessionStorage.setItem('productShortDescription', productList.product_description)
        sessionStorage.setItem('productLongDescription', productList.prod_description)
        sessionStorage.setItem('brandName', productList.brand_name)
        sessionStorage.setItem('isEditSubscription', productList.subscription)
        sessionStorage.setItem('subscriptionType', productList.subscription_type)
        var subscriptionId = 0
        if (productList.subscription_id !== 'undefined') {
          subscriptionId = productList.subscription_id
        }
        sessionStorage.setItem('subscriptionId', subscriptionId)
        this.$router.push('/a/editSubscription')
      }
    },
    addCurrentProduct (product) {
      this.currentProduct(product)
    }
  }
}
</script>

<style scoped>
  .listOfProducts {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 0;
  }

  .product {
    width: 98%;
    background-color: #fff;
    list-style: none;
    box-sizing: border-box;
    padding: 1em;
    margin: .2em 0;
    /*display: flex;*/
    flex-direction: column;
    align-items: center;
    border-radius: 7px;
  }

  .product-image{
    height: 80px;
    width: 80px;
    border-radius: 50%;
  }

  .subButton{
    border: 0;
    border-radius: 3px;
    color: #fff;
    font-weight: 300;
    /*background-color: #3CB6C3;*/
    height:26px;
    width:90px;
    font-size: 11px
  }

  .image {
    /*position: relative; */
    margin: 0 auto; /* Center it */
  }

  .imageText {
    position: absolute; /* Position the background text */
    bottom: 0; /* At the bottom. Use top:0 to append it to the top */
    color: #f1f1f1; /* Grey text */
    width: 100%; /* Full width */
    padding: 20px; /* Some padding */
  }

</style>




// WEBPACK FOOTER //
// src/components/List/ListOfProducts.vue